class Utils {

    // snippets from http://youmightnotneedjquery.com/ + more

    constructor() {
    }

    hasClass( el, className ) {
        if ( el.classList ) {
            return el.classList.contains(className);
        } else {
            return new RegExp('(^| )' + className + '( |$)', 'gi').test(el.className);
        }
    }
    toggleClass( el, className ) {
        if (el.classList) {
            el.classList.toggle(className);
        } else {
            var classes = el.className.split(' ');
            var existingIndex = classes.indexOf(className);

            if (existingIndex >= 0)
                classes.splice(existingIndex, 1);
            else
                classes.push(className);
            el.className = classes.join(' ');
        }
    }
    addClass( el, className ) {
        if (el.classList) {
            el.classList.add(className);
        } else {
            el.className += ' ' + className;
        }
    }
    removeClass( el, className ) {
        if ( el.classList ) {
            el.classList.remove(className);
        } else {
            el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        }
    }

    matchesElement(el, selector) {
        return (el.matches || el.matchesSelector || el.msMatchesSelector || el.mozMatchesSelector || el.webkitMatchesSelector || el.oMatchesSelector).call(el, selector);
    }

    getStyles( el ) {
        return window.getComputedStyle
            ? getComputedStyle(el, null)
            : el.currentStyle;
    }

    isElementInView( element, fullyInView ) {

        var bounding = element.getBoundingClientRect();
        return (
            bounding.top >= 0 &&
            bounding.left >= 0 &&
            bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
        // if (fullyInView === true) {
        //     return ((pageTop < elementTop) && (pageBottom > elementBottom));
        // } else {
        //     return ((elementTop <= pageBottom) && (elementBottom >= pageTop));
        // }
    }

    debounce(func, wait, immediate) {
        var timeout;
        return function() {
            var context = this, args = arguments;
            var later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }

    offset(el) {
	    var rect = el.getBoundingClientRect(),
	    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
	    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
    }

    preventDefault(e) {
        e = e || window.event;
        if (e.preventDefault) {
            e.preventDefault();
        }
        e.returnValue = false;
    }

    preventDefaultForScrollKeys(e) {
        var keys = {37: 1, 38: 1, 39: 1, 40: 1};
        if (keys[e.keyCode]) {
            preventDefault(e);
            return false;
        }
    }

    disableScroll() {

        let self = this;

        if ( window.addEventListener ) { // older FF
            window.addEventListener('DOMMouseScroll', self.preventDefault, false);
        }
        window.onwheel      = self.preventDefault; // modern standard
        window.onmousewheel = document.onmousewheel = self.preventDefault; // older browsers, IE
        window.ontouchmove  = self.preventDefault; // mobile
        document.onkeydown  = self.preventDefaultForScrollKeys;

    }

    enableScroll() {

        if ( window.removeEventListener ) {
            window.removeEventListener('DOMMouseScroll', self.preventDefault, false);
        }
        window.onmousewheel = document.onmousewheel = null;
        window.onwheel      = null;
        window.ontouchmove  = null;
        document.onkeydown  = null;

    }

} // class Utils

export let utils = new Utils();